import * as auth from "../app/modules/Auth/_redux/authRedux"
import Axios from "axios"

const REFRESH_TOKEN_URL = `${process.env.REACT_APP_API_URL}auth/refresh`

export const getOwnerRefreshToken = (refreshToken) => {
    return Axios.post(REFRESH_TOKEN_URL, refreshToken)
}

export default function setupAxios(axios, store) {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    axios.interceptors.request.use(
        (config) => {
            const {
                auth: {token},
            } = store.getState();

            if (token) {
                config.headers.Authorization = `bearer ${token}`;
            }

            return config;
        },
        (err) => Promise.reject(err)
    );
    axios.interceptors.response.use(
        (response) => {
            return response;
        }, async (error) => {
            const {dispatch} = store;
            const {actions: { logout}} = auth
            const response = error.response;

            if (response) {
                if (
                    response.status === 401
                ) {
                    dispatch(logout());
                }
            }
            return Promise.reject(error);
        }
    );
}
